import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

// Import images directly (only member images needed)
import bauchiFlyer from '../assets/NAUS_Bauchi_Flyer.jpeg';
import abstractsFlyer from '../assets/NAUS Abstracts.jpg'; // TODO: update filename to match your actual file
import bauchiflyer2 from '../assets/NAUS_2nd_reg_flyer.jpeg'; // TODO: update filename to match your actual file
import augustineImage from '../assets/Augustine. O. Takure.jpeg';
import ngoziImage from '../assets/Prof Ngozi Ekeke.jpeg';
import samailaImage from '../assets/Prof Samaila Shuaibu .jpeg';
import johnImage from '../assets/Prof. John E Raphael.jpeg';
import timImage from '../assets/Prof Tim Uzoma Mbaeri.jpeg';
import ikennaImage from '../assets/Prof. Ikenna I Nnabugwu.jpeg';
import terkaaImage from '../assets/Prof. Terkaa Atim.jpeg';
import muhammedImage from '../assets/Prof Muhammed Ahmed.jpeg';
import nuhuImage from '../assets/Prof Nuhu K. Dakum.jpeg';

// Board Members Data
const boardMembers = [
  { id: 1, name: "Augustine O. Takure", position: "President", image: augustineImage },
  { id: 2, name: "Prof Ngozi Ekeke", position: "President - Elect", image: ngoziImage },
  { id: 3, name: "Prof Samaila Shuaibu", position: "Secretary General", image: samailaImage },
  { id: 4, name: "Prof John E Raphael", position: "Assistant Secretary General", image: johnImage },
  { id: 5, name: "Prof Tim Uzoma Mbaeri", position: "Treasurer", image: timImage },
  { id: 6, name: "Prof Ikenna I Nnabugwu", position: "Financial Secretary", image: ikennaImage },
  { id: 7, name: "Prof Terkaa Atim", position: "Public Relations Officer", image: terkaaImage },
  { id: 8, name: "Prof Muhammed Ahmed", position: "Editor-in-Chief, Nigerian Journal of Urology", image: muhammedImage },
  { id: 9, name: "Prof Nuhu K. Dakum", position: "Ex-Officio", image: nuhuImage }
];

const CONFERENCE_URL = 'https://iventmaster.com/naus-bauchi2026';

// FLYERS DATA - add more entries here as new event flyers come in.
const flyers = [
  {
    id: 1,
    src: bauchiFlyer,
    alt: 'NAUS Bauchi 2026 Annual Conference',
    caption: 'Secure your spot at the NAUS Annual Conference — Bauchi 2026',
    buttonText: 'Register for Annual Conference',
    url: CONFERENCE_URL
  },
  {
    id: 2,
    src: bauchiflyer2,
  },
  {
    id: 3,
    src: abstractsFlyer,
    alt: 'Call for Abstracts',
    caption: 'Submit your abstract for consideration'
  }
];

const Home = () => {
  const navigate = useNavigate();
  const [journalBtnHovered, setJournalBtnHovered] = useState(false);
  const [showMembers, setShowMembers] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const [showFlyerPopup, setShowFlyerPopup] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [newsImages, setNewsImages] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [newsLoading, setNewsLoading] = useState(true);

  // Flyer carousel state
  const [currentFlyer, setCurrentFlyer] = useState(0);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  // Countdown state
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
  const [isEventStarted, setIsEventStarted] = useState(false);

  const minSwipeDistance = 50;

  const nextFlyer = () => setCurrentFlyer((prev) => (prev + 1) % flyers.length);
  const prevFlyer = () => setCurrentFlyer((prev) => (prev - 1 + flyers.length) % flyers.length);
  const goToFlyer = (index) => setCurrentFlyer(index);

  const onFlyerTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };
  const onFlyerTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };
  const onFlyerTouchEnd = () => {
    if (touchStart == null || touchEnd == null) return;
    const distance = touchStart - touchEnd;
    if (distance > minSwipeDistance) {
      nextFlyer();
    } else if (distance < -minSwipeDistance) {
      prevFlyer();
    }
  };

  const activeFlyer = flyers[currentFlyer];

  const handleMemberClick = (member) => {
    setSelectedMember(member);
  };

  const closeMemberModal = () => {
    setSelectedMember(null);
  };

  const closeGallery = () => {
    setShowMembers(false);
  };

  // Countdown Timer Effect
  useEffect(() => {
    const targetDate = new Date('2026-11-25T00:00:00');

    const updateCountdown = () => {
      const now = new Date();
      const difference = targetDate - now;

      if (difference <= 0) {
        setIsEventStarted(true);
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      } else {
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((difference / 1000 / 60) % 60);
        const seconds = Math.floor((difference / 1000) % 60);
        setTimeLeft({ days, hours, minutes, seconds });
      }
    };

    updateCountdown();
    const timer = setInterval(updateCountdown, 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const gallery = document.querySelector('.board-gallery-container');
      if (gallery && showMembers && !gallery.contains(event.target) && !selectedMember) {
        closeGallery();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showMembers, selectedMember]);

  useEffect(() => {
    document.body.style.overflow = (showMembers || selectedMember || showFlyerPopup) ? 'hidden' : 'unset';
  }, [showMembers, selectedMember, showFlyerPopup]);

  // Fetch news images from WordPress CMS
  useEffect(() => {
    const fetchNews = async () => {
      try {
        const res = await axios.get("https://cms.nausurology.org/wp-json/wp/v2/posts?_embed");
        const images = res.data
          .map(post => ({
            id: post.id,
            title: post.title.rendered,
            imageUrl: post._embedded?.['wp:featuredmedia']?.[0]?.source_url,
            slug: post.slug
          }))
          .filter(item => item.imageUrl);
        setNewsImages(images);
      } catch (err) {
        console.error("Error fetching news:", err);
      } finally {
        setNewsLoading(false);
      }
    };
    fetchNews();
  }, []);

  // Auto-advance slideshow
  useEffect(() => {
    if (newsImages.length <= 1) return;
    const interval = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % newsImages.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [newsImages.length]);

  const goToSlide = (index) => setCurrentSlide(index);
  const nextSlide = () => setCurrentSlide(prev => (prev + 1) % newsImages.length);
  const prevSlide = () => setCurrentSlide(prev => (prev - 1 + newsImages.length) % newsImages.length);

  return (
    <div style={{
      maxWidth: '1200px',
      margin: '0 auto',
      minHeight: '100vh',
      padding: isMobile ? '2rem 1rem' : '2rem 2rem',
      position: 'relative',
      overflow: 'hidden'
    }}>

      {/* BALLOON CELEBRATION STYLES & OVERLAY WHEN EVENT REACHED */}
      {isEventStarted && (
        <>
          <style>{`
            @keyframes floatUp {
              0% { transform: translateY(100vh) scale(0.8); opacity: 0; }
              50% { opacity: 1; }
              100% { transform: translateY(-120vh) scale(1.1); opacity: 0; }
            }
            .celebration-balloon {
              position: fixed;
              bottom: -100px;
              font-size: 3rem;
              animation: floatUp 6s ease-in-out infinite;
              z-index: 2000;
              user-select: none;
              pointer-events: none;
            }
          `}</style>
          {/* Floating celebratory balloons & confetti */}
          <div className="celebration-balloon" style={{ left: '5%', animationDelay: '0s' }}>🎈</div>
          <div className="celebration-balloon" style={{ left: '15%', animationDelay: '1.2s' }}>🎉</div>
          <div className="celebration-balloon" style={{ left: '30%', animationDelay: '0.5s' }}>🎈</div>
          <div className="celebration-balloon" style={{ left: '45%', animationDelay: '2s' }}>🎊</div>
          <div className="celebration-balloon" style={{ left: '60%', animationDelay: '0.8s' }}>🎈</div>
          <div className="celebration-balloon" style={{ left: '75%', animationDelay: '1.5s' }}>🎉</div>
          <div className="celebration-balloon" style={{ left: '90%', animationDelay: '0.3s' }}>🎈</div>
        </>
      )}

      {/* CONFERENCE FLYER POPUP */}
      {showFlyerPopup && (
        <div
          onClick={() => setShowFlyerPopup(false)}
          style={{
            position: 'fixed',
            top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.88)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 3000,
            padding: isMobile ? '12px' : '24px',
            backdropFilter: 'blur(4px)'
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              backgroundColor: 'white',
              borderRadius: '16px',
              overflow: 'hidden',
              maxWidth: isMobile ? 'calc(100vw - 16px)' : '620px',
              width: '100%',
              boxShadow: '0 32px 80px rgba(0,0,0,0.6)',
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            {/* Header bar */}
            <div style={{
              background: 'linear-gradient(135deg, #006400 0%, #228B22 100%)',
              padding: '14px 18px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              flexShrink: 0
            }}>
              <span style={{
                color: 'white',
                fontWeight: 'bold',
                fontSize: isMobile ? '0.9rem' : '1rem',
                letterSpacing: '0.3px'
              }}>
                Upcoming Event{flyers.length > 1 ? `s (${currentFlyer + 1}/${flyers.length})` : ''}
              </span>
              <button
                onClick={() => setShowFlyerPopup(false)}
                style={{
                  background: 'rgba(255,255,255,0.2)',
                  color: 'white',
                  border: '1.5px solid rgba(255,255,255,0.5)',
                  borderRadius: '50%',
                  width: '32px',
                  height: '32px',
                  fontSize: '20px',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  lineHeight: 1,
                  transition: 'background 0.2s'
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(220,20,60,0.85)'}
                onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.2)'}
              >×</button>
            </div>

            {/* Flyer image - swipeable carousel */}
            <div
              style={{
                width: '100%',
                backgroundColor: '#000',
                flexShrink: 0,
                position: 'relative',
                overflow: 'hidden',
                touchAction: 'pan-y'
              }}
              onTouchStart={onFlyerTouchStart}
              onTouchMove={onFlyerTouchMove}
              onTouchEnd={onFlyerTouchEnd}
            >
              <img
                src={activeFlyer.src}
                alt={activeFlyer.alt}
                style={{
                  width: '100%',
                  display: 'block',
                  objectFit: 'contain',
                  maxHeight: isMobile ? '70vw' : '500px',
                  userSelect: 'none',
                  pointerEvents: 'none'
                }}
                draggable={false}
              />

              {flyers.length > 1 && (
                <>
                  <button
                    onClick={(e) => { e.stopPropagation(); prevFlyer(); }}
                    style={{
                      position: 'absolute',
                      left: '10px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      backgroundColor: 'rgba(0, 100, 0, 0.8)',
                      color: 'white',
                      border: 'none',
                      borderRadius: '50%',
                      width: isMobile ? '32px' : '40px',
                      height: isMobile ? '32px' : '40px',
                      cursor: 'pointer',
                      fontSize: isMobile ? '1.1rem' : '1.4rem',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      zIndex: 10,
                      transition: 'background-color 0.3s'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(0, 100, 0, 1)'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'rgba(0, 100, 0, 0.8)'}
                  >
                    &#8249;
                  </button>
                  <button
                    onClick={(e) => { e.stopPropagation(); nextFlyer(); }}
                    style={{
                      position: 'absolute',
                      right: '10px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      backgroundColor: 'rgba(0, 100, 0, 0.8)',
                      color: 'white',
                      border: 'none',
                      borderRadius: '50%',
                      width: isMobile ? '32px' : '40px',
                      height: isMobile ? '32px' : '40px',
                      cursor: 'pointer',
                      fontSize: isMobile ? '1.1rem' : '1.4rem',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      zIndex: 10,
                      transition: 'background-color 0.3s'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(0, 100, 0, 1)'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'rgba(0, 100, 0, 0.8)'}
                  >
                    &#8250;
                  </button>

                  <div style={{
                    position: 'absolute',
                    bottom: '10px',
                    left: 0,
                    right: 0,
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '8px',
                    zIndex: 10
                  }}>
                    {flyers.map((_, index) => (
                      <button
                        key={index}
                        onClick={(e) => { e.stopPropagation(); goToFlyer(index); }}
                        style={{
                          width: index === currentFlyer ? '22px' : '9px',
                          height: '9px',
                          borderRadius: '5px',
                          backgroundColor: index === currentFlyer ? '#fff' : 'rgba(255,255,255,0.6)',
                          border: 'none',
                          cursor: 'pointer',
                          transition: 'all 0.3s ease',
                          padding: 0
                        }}
                      />
                    ))}
                  </div>
                </>
              )}
            </div>

            <div style={{
              padding: isMobile ? '0.25rem 1rem' : '0.3rem 1.4rem',
              background: 'linear-gradient(180deg, #f0f7f0 0%, #ffffff 100%)',
              textAlign: 'center',
              borderTop: '3px solid #006400',
              flexShrink: 0
            }}>
              <p style={{
                margin: '0 0 0.25rem',
                color: '#444',
                fontSize: isMobile ? '0.8rem' : '0.88rem',
                fontWeight: '500'
              }}>
                {activeFlyer.caption}
              </p>

              {activeFlyer.url && (
                <a
                  href={activeFlyer.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: 'inline-block',
                    background: 'linear-gradient(135deg, #006400 0%, #228B22 100%)',
                    color: 'white',
                    textDecoration: 'none',
                    padding: isMobile ? '0.55rem 1.4rem' : '0.65rem 2rem',
                    borderRadius: '8px',
                    fontWeight: 'bold',
                    fontSize: isMobile ? '0.95rem' : '1rem',
                    boxShadow: '0 4px 16px rgba(0,100,0,0.35)',
                    transition: 'all 0.2s ease',
                    letterSpacing: '0.2px'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = '#004d00';
                    e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,100,0,0.5)';
                    e.currentTarget.style.transform = 'translateY(-1px)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = 'linear-gradient(135deg, #006400 0%, #228B22 100%)';
                    e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,100,0,0.35)';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  {activeFlyer.buttonText}
                </a>
              )}

              <p style={{
                margin: '0.2rem 0 0',
                color: '#999',
                fontSize: '0.72rem'
              }}>
                {flyers.length > 1 ? 'Swipe or use arrows to see more · Click outside to close' : 'Click anywhere outside to close'}
              </p>
            </div>
          </div>
        </div>
      )}

      {/* PERSISTENT CONFERENCE BUTTON & COUNTDOWN BANNER */}
      {!showFlyerPopup && (
        <div style={{
          textAlign: 'center',
          marginBottom: '1.5rem',
          padding: isMobile ? '0.8rem 1rem' : '1rem',
          background: 'linear-gradient(135deg, #f0f7f0, #e8f5e8)',
          borderRadius: '12px',
          border: '1px solid #c8e6c9'
        }}>
          <p style={{
            margin: '0 0 0.6rem',
            color: '#006400',
            fontWeight: '600',
            fontSize: isMobile ? '0.85rem' : '0.9rem'
          }}>
            NAUS Annual Conference — Bauchi 2026
          </p>

          {/* LIVE COUNTDOWN / CELEBRATION BANNER */}
          <div style={{
            margin: '0.5rem auto 0.8rem',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: isMobile ? '8px' : '16px',
            flexWrap: 'wrap'
          }}>
            {isEventStarted ? (
              <div style={{
                fontSize: isMobile ? '1.1rem' : '1.3rem',
                fontWeight: 'bold',
                color: '#006400',
                padding: '0.4rem 1rem',
                backgroundColor: '#fff',
                borderRadius: '8px',
                boxShadow: '0 2px 8px rgba(0,100,0,0.15)'
              }}>
                🎉 The Conference Day is Here! Happy Celebration! 🎈
              </div>
            ) : (
              <>
                <div style={{ background: '#fff', padding: '6px 12px', borderRadius: '6px', boxShadow: '0 2px 6px rgba(0,0,0,0.05)' }}>
                  <span style={{ fontSize: isMobile ? '1rem' : '1.2rem', fontWeight: 'bold', color: '#006400' }}>{timeLeft.days}</span>
                  <span style={{ fontSize: '0.75rem', display: 'block', color: '#666' }}>Days</span>
                </div>
                <div style={{ background: '#fff', padding: '6px 12px', borderRadius: '6px', boxShadow: '0 2px 6px rgba(0,0,0,0.05)' }}>
                  <span style={{ fontSize: isMobile ? '1rem' : '1.2rem', fontWeight: 'bold', color: '#006400' }}>{timeLeft.hours}</span>
                  <span style={{ fontSize: '0.75rem', display: 'block', color: '#666' }}>Hours</span>
                </div>
                <div style={{ background: '#fff', padding: '6px 12px', borderRadius: '6px', boxShadow: '0 2px 6px rgba(0,0,0,0.05)' }}>
                  <span style={{ fontSize: isMobile ? '1rem' : '1.2rem', fontWeight: 'bold', color: '#006400' }}>{timeLeft.minutes}</span>
                  <span style={{ fontSize: '0.75rem', display: 'block', color: '#666' }}>Mins</span>
                </div>
                <div style={{ background: '#fff', padding: '6px 12px', borderRadius: '6px', boxShadow: '0 2px 6px rgba(0,0,0,0.05)' }}>
                  <span style={{ fontSize: isMobile ? '1rem' : '1.2rem', fontWeight: 'bold', color: '#006400' }}>{timeLeft.seconds}</span>
                  <span style={{ fontSize: '0.75rem', display: 'block', color: '#666' }}>Secs</span>
                </div>
              </>
            )}
          </div>

          <a
            href={CONFERENCE_URL}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-block',
              background: 'linear-gradient(135deg, #006400 0%, #228B22 100%)',
              color: 'white',
              textDecoration: 'none',
              padding: isMobile ? '0.75rem 1.5rem' : '0.85rem 2rem',
              borderRadius: '8px',
              fontWeight: 'bold',
              fontSize: isMobile ? '0.95rem' : '1rem',
              boxShadow: '0 4px 14px rgba(0,100,0,0.3)',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#004d00';
              e.currentTarget.style.boxShadow = '0 6px 18px rgba(0,100,0,0.45)';
              e.currentTarget.style.transform = 'translateY(-1px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'linear-gradient(135deg, #006400 0%, #228B22 100%)';
              e.currentTarget.style.boxShadow = '0 4px 14px rgba(0,100,0,0.3)';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            Register for Annual Conference
          </a>
        </div>
      )}

      {/* Hero Section */}
      {isMobile ? (
        <div style={{ textAlign: 'center' }}>
          <h1 className="naus-title">
            Association of Urological Surgeons, Nigeria
          </h1>

          <p style={{
            fontSize: '1.15rem',
            lineHeight: '1.6',
            marginBottom: '2rem',
            color: '#555555',
            fontWeight: '500'
          }}>
            Advancing urological surgery excellence in Nigeria through education, research, and advocacy.
          </p>

          <div style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '0.75rem',
            flexWrap: 'wrap',
            marginBottom: '2rem'
          }}>
            <button onClick={() => navigate('/membership')} style={{ backgroundColor: '#006400', color: 'white', padding: '0.6rem 1.2rem', borderRadius: '4px', fontWeight: 'bold', border: 'none', cursor: 'pointer' }}>Join Us</button>
            <button onClick={() => navigate('/about')} style={{ backgroundColor: '#228B22', color: 'white', padding: '0.6rem 1.2rem', borderRadius: '4px', fontWeight: 'bold', border: 'none', cursor: 'pointer' }}>Learn More</button>
            <button onClick={() => navigate('/training')} style={{ backgroundColor: '#2E8B57', color: 'white', padding: '0.6rem 1.2rem', borderRadius: '4px', fontWeight: 'bold', border: 'none', cursor: 'pointer' }}>Training Programs</button>
          </div>
        </div>
      ) : (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '2rem',
          marginBottom: '2rem',
          minHeight: '280px'
        }}>
          <div style={{ flexShrink: 0, width: '180px' }}></div>

          <div style={{ flex: 1, textAlign: 'left', paddingRight: '2rem' }}>
            <h1 className="naus-title">
              Association of Urological Surgeons, Nigeria
            </h1>

            <p style={{
              fontSize: '1.25rem',
              lineHeight: '1.6',
              color: '#555555',
              fontWeight: '500',
              margin: 0
            }}>
              Advancing urological surgery excellence in Nigeria through education, research, and advocacy.
            </p>
          </div>

          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem',
            flexShrink: 0
          }}>
            <button
              onClick={() => navigate('/membership')}
              style={{
                backgroundColor: '#006400',
                color: 'white',
                padding: '0.85rem 2rem',
                borderRadius: '6px',
                fontWeight: 'bold',
                border: 'none',
                cursor: 'pointer',
                fontSize: '1rem',
                transition: 'all 0.2s ease',
                minWidth: '180px'
              }}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#004d00'}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#006400'}
            >
              Join Us
            </button>
            <button
              onClick={() => navigate('/about')}
              style={{
                backgroundColor: '#228B22',
                color: 'white',
                padding: '0.85rem 2rem',
                borderRadius: '6px',
                fontWeight: 'bold',
                border: 'none',
                cursor: 'pointer',
                fontSize: '1rem',
                transition: 'all 0.2s ease',
                minWidth: '180px'
              }}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#1e7b1e'}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#228B22'}
            >
              Learn More
            </button>
            <button
              onClick={() => navigate('/training')}
              style={{
                backgroundColor: '#2E8B57',
                color: 'white',
                padding: '0.85rem 2rem',
                borderRadius: '6px',
                fontWeight: 'bold',
                border: 'none',
                cursor: 'pointer',
                fontSize: '1rem',
                transition: 'all 0.2s ease',
                minWidth: '180px'
              }}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#267349'}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#2E8B57'}
            >
              Training Programs
            </button>
          </div>
        </div>
      )}

      {/* NEWS IMAGES SLIDESHOW */}
      <div style={{
        margin: isMobile ? '2rem 0' : '3rem 0',
        padding: '2rem',
        backgroundColor: '#f8f9fa',
        borderRadius: '12px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
      }}>
        <h2 style={{
          color: '#006400',
          fontSize: isMobile ? '1.5rem' : '2rem',
          marginBottom: '1.5rem',
          textAlign: 'center'
        }}>
          Latest News & Updates
        </h2>

        {newsLoading ? (
          <div style={{ textAlign: 'center', padding: '2rem', color: '#666' }}>
            Loading news...
          </div>
        ) : newsImages.length > 0 ? (
          <div style={{ position: 'relative' }}>
            <div style={{
              position: 'relative',
              width: '100%',
              height: isMobile ? '250px' : '400px',
              borderRadius: '8px',
              overflow: 'hidden',
              backgroundColor: '#fff'
            }}>
              {newsImages.map((news, index) => (
                <div
                  key={news.id}
                  onClick={() => navigate(`/news/${news.slug}`)}
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    opacity: index === currentSlide ? 1 : 0,
                    transition: 'opacity 0.5s ease-in-out',
                    cursor: 'pointer'
                  }}
                >
                  <img
                    src={news.imageUrl}
                    alt={news.title}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'contain',
                      backgroundColor: '#fff'
                    }}
                  />
                  <div style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    background: 'linear-gradient(transparent, rgba(0,0,0,0.8))',
                    padding: '2rem 1rem 1rem',
                    color: 'white'
                  }}>
                    <h3
                      style={{
                        fontSize: isMobile ? '0.9rem' : '1.2rem',
                        margin: 0,
                        textShadow: '1px 1px 2px rgba(0,0,0,0.5)'
                      }}
                      dangerouslySetInnerHTML={{ __html: news.title }}
                    />
                  </div>
                </div>
              ))}

              {newsImages.length > 1 && (
                <>
                  <button
                    onClick={(e) => { e.stopPropagation(); prevSlide(); }}
                    style={{
                      position: 'absolute',
                      left: '10px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      backgroundColor: 'rgba(0, 100, 0, 0.8)',
                      color: 'white',
                      border: 'none',
                      borderRadius: '50%',
                      width: isMobile ? '35px' : '45px',
                      height: isMobile ? '35px' : '45px',
                      cursor: 'pointer',
                      fontSize: isMobile ? '1.2rem' : '1.5rem',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      zIndex: 10,
                      transition: 'background-color 0.3s'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(0, 100, 0, 1)'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'rgba(0, 100, 0, 0.8)'}
                  >
                    &#8249;
                  </button>
                  <button
                    onClick={(e) => { e.stopPropagation(); nextSlide(); }}
                    style={{
                      position: 'absolute',
                      right: '10px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      backgroundColor: 'rgba(0, 100, 0, 0.8)',
                      color: 'white',
                      border: 'none',
                      borderRadius: '50%',
                      width: isMobile ? '35px' : '45px',
                      height: isMobile ? '35px' : '45px',
                      cursor: 'pointer',
                      fontSize: isMobile ? '1.2rem' : '1.5rem',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      zIndex: 10,
                      transition: 'background-color 0.3s'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(0, 100, 0, 1)'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'rgba(0, 100, 0, 0.8)'}
                  >
                    &#8250;
                  </button>
                </>
              )}
            </div>

            {newsImages.length > 1 && (
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                gap: '8px',
                marginTop: '1rem'
              }}>
                {newsImages.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => goToSlide(index)}
                    style={{
                      width: index === currentSlide ? '24px' : '10px',
                      height: '10px',
                      borderRadius: '5px',
                      backgroundColor: index === currentSlide ? '#006400' : '#ccc',
                      border: 'none',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease'
                    }}
                  />
                ))}
              </div>
            )}

            <div style={{ textAlign: 'center', marginTop: '1.5rem' }}>
              <button
                onClick={() => navigate('/news')}
                style={{
                  backgroundColor: '#006400',
                  color: 'white',
                  border: 'none',
                  padding: '0.7rem 1.5rem',
                  borderRadius: '6px',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  transition: 'background-color 0.3s'
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#004d00'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#006400'}
              >
                View All News
              </button>
            </div>
          </div>
        ) : (
          <div style={{ textAlign: 'center', padding: '2rem', color: '#666' }}>
            No news available at the moment.
          </div>
        )}
      </div>

      <div style={{ marginBottom: '3rem', textAlign: 'center' }}>
        <button
          onClick={() => setShowMembers(true)}
          style={{
            backgroundColor: '#006400',
            color: 'white',
            border: 'none',
            padding: isMobile ? '0.8rem 1.5rem' : '1rem 2rem',
            fontSize: '1rem',
            fontWeight: 'bold',
            borderRadius: '8px',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            boxShadow: '0 4px 8px rgba(0, 100, 0, 0.3)'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#004d00';
            e.currentTarget.style.transform = 'scale(1.05)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = '#006400';
            e.currentTarget.style.transform = 'scale(1)';
          }}
        >
          Meet Our Executive Committee Officers
        </button>
      </div>

    </div>
  );
};

export default Home;